import React, { useState, useEffect } from 'react';
import ComboSelector, { TipoClave } from './ComboSelector.js';
import useGetListaURL from '../../../hooks/useGetListaURL.js';
import { NombreEquipoTorneo } from '../../funciones/FuncionesEquipo.js';

const CampoComboEquipoEditable = (props) => {
  const nombre = props.nombre;
  const valor = props.valor;
  const equiposExternos = props.equipos;
  const estilo = props.estilo;
  const torneo = props.torneo;
  const idTorneo = props.torneo?.id;

  const [equipos, setEquipos] = useState(equiposExternos || []);
  const { isCargando, fetchData } = useGetListaURL();

  console.log('CampoComboEquipoEditable - Torneo:', props.torneo, idTorneo, equiposExternos);

  useEffect(() => {
    // Si el prop fue provisto explícitamente no llamar a la API
    if (equiposExternos !== undefined && equiposExternos !== null && equiposExternos.length > 0) {
      setEquipos(equiposExternos || []);
      return;
    }

    // Cargar equipos según el torneo
    if (idTorneo) {
      fetchData('/torneos/' + idTorneo + '/participantes/candidatos', setEquipos);
    } else {
      setEquipos([]);
    }
  }, [idTorneo, fetchData, equiposExternos]);

  const onEquipoElegido = (equipoSeleccionado) => {
    props.onChange(nombre, equipoSeleccionado);
  };

  // Crear lista formateada para el combo
  const listaFormateada = equipos.map((equipo) => ({
    ...equipo,
    nombreFormateado: NombreEquipoTorneo(equipo, torneo),
  }));

  return (
    <ComboSelector
      estilo={estilo}
      lista={listaFormateada}
      valorActual={valor ? NombreEquipoTorneo(valor, torneo) : ''}
      campoClave={TipoClave.ID}
      campoDescripcion="nombreFormateado"
      isCargando={isCargando}
      onItemElegido={onEquipoElegido}
    />
  );
};

export default CampoComboEquipoEditable;
